/**
 * @description Các route của phần mềm, luôn phải khai báo toàn bộ route ở đây và theo loại route, nếu không phần mềm sẽ không hoạt động theo ý muốn
 * @author PSC Portal - Front-end developer
 * @version 1.0.0
 * @since 11/03/2025
 */

/**App name của phần mềm */
export const APP_NAME = {
    /**Site dành cho cán bộ nhân viên xử lý hồ sơ */
    MOT_CUA: 'MOT_CUA',
    /**Site dành cho sinh viên, khách hàng nộp hồ sơ */
    ONE_GATE: 'ONE_GATE',
};

/**Các route dành cho layout admin */
export const pageDirectories = {
    /**
     * Redirect path
     * When user access, web will check the roles of user,
     * Depending on the user's permission group, the system will automatically redirect to the correct site
     * */
    Landing: '/',

    /**Home page auth will push if no callback supply after singin */
    Home: '/dashboard',
    //-----------------
    Signin: '/signin',
    SigninSSO: '/signin/sso',
    Signup: '/signup',
    Forgor: '/forgor',
    RePassword: '/re-password',
    SignOut: '/signout',
    SignOutFallback: '/signout-fallback',
    //-----------------
    NotFound: '/404',
    TermOfService: '/terms',
    PrivacyPolicy: '/privacy',
    Contact: '/contact',

    /**Quản lý phần mềm */
    AppConfig: '/app-config',

    /**Người dùng routes */
    Staff: '/staff',
    StaffModify: '/staff/modify',
    Department: '/department',
    Position: '/position',
    Role: '/role',
    WorkingGroup: '/working-group',
    Menu: '/menu',
    Page: '/page',
    Function: '/func',
    Permission: '/permit',

    /**Quản trị đồng bộ user SSO */
    SsoUserSync: '/sso-user-sync',

    ProfileInfo: '/profile',

    /**Hệ thống routes */
    Notification: '/notification',
    Holiday: '/holiday',
    WorkingSchedule: '/working-schedule',
    Language: '/language',
    LanguageResource: '/language-resource',
    /**
     * @description Cấu hình ứng dụng, nơi quản lý các thông tin cấu hình của phần mềm
     */
    AppSettings: '/app-settings',

    /**Quản lý yêu cầu nghiệp vụ */
    BusinessRequirement: '/business-requirement',

    /**Nhật ký gửi email */
    EmailSendLog: '/email-send-log',

    /**Thủ tục hành chính routes */
    Field: '/field',
    DeclarationForm: '/declaration-form',
    ModifyProcedure: '/procedure/modify',
    EditingProcedure: '/procedure/edit',
    ProcedureDraftManagement: '/procedure/draft',
    ProcedureInUseManagement: '/procedure/in-use',
    ProcedureWaitingManagement: '/procedure/waiting',
    ProcedureTakeEffectManagement: '/procedure/take-effect',
    ProcedureExpireManagement: '/procedure/expire',
    /**Chi tiết thủ tục của trang nhân viên (Một cửa) */
    ProcedureStaffDetail: '/procedure/detail',
    ProcedureList: '/procedure',
    EmailTemplate: '/email-template',
    StatisticalDetail: '/statistical-details',
    MergeField: '/merge-field',
    ProcedureType: '/procedure-type',

    /**Cơ quan hành chính */
    AdministrativeUnit: '/administrative-unit',

    /**Văn bản pháp luật */
    LegalDocument: '/legal-document',

    /**Cusomter management routes */
    Customer: '/customers',
    UserServiceQuality: '/user-service-quality',

    /**Một cửa routes------------------------ */
    Dossiers_JobImportant: '/dossier/job-important',
    Dossiers_JobProcessing: '/dossier/job-processing',
    Dossiers_JobWaitingReceive: '/dossier/job-waiting-receive',
    Dossiers_JobTransferred: '/dossier/job-transferred',
    Dossiers_DueDate: '/dossier/due-date',
    Dossiers_ReceivedWaitingTransfer: '/dossier/received-waitting-transer',
    Dossiers_Processing: '/dossier/processing',
    Dossiers_StopCounting: '/dossier/stop',
    Dossiers_WaitingReturn: '/dossier/waiting-return',
    Dossiers_Returned: '/dossier/returned',
    Dossiers_Refused: '/dossier/refused',
    Dossiers_Cancel: '/dossier/cancel',
    Dossiers_WaitingCoordination: '/dossier/waiting-coordination',
    Dossiers_All: '/dossier/all',
    Dossiers_OverDue: '/dossier/overdue',
    DossiersServiceQuality: '/dossiers-service-quality',

    DossierDetail: '/dossier/detail',
    /**Route xử lý chi tiết hồ sơ */
    DossierProcessing: '/dossier/processing',

    /**END Một cửa routes------------------------ */

    /**
     * Customer routes-----------------------------------
     * */

    /**Chi tiết thủ tục public */
    Customer_ProcedureDetail: '/procedure-detail',
    /**Nộp hồ sơ */
    Customer_SubmitDossier: '/cust-dossier',
    /**Thông tin tài khoản */
    Customer_AccountInfo: '/account-info',
    /**Danh sách hồ sơ của sinh viên */
    Customer_DossierList: '/my-dossier',
    /**Giới thiệu */
    Customer_Introduction: '/introduction',
    /**Danh sách thủ tục */
    Customer_ProcedureList: '/procedure-list',
    /**Tìm kiếm hồ sơ bằng số biên nhận */
    Customer_LookUpDossier: '/look-up-dossier',
    /**Thống kê công khai */
    Customer_PublicStatistics: '/public-statistics',
    /**Đổi mật khẩu */
    Customer_Password: '/password',
    /**Quản lý giấy tờ */
    Customer_Paper: '/paper',
    /**Khảo sát ESurvey */
    Customer_Survey: '/survey',

    /**
     * UTILS ----
     */
    ExcelUtils: '/utils/excel',
};

/** Các route dành cho layout của customer */
export const pageCustomerDirectories = {
    SubmitDossier: pageDirectories.Customer_SubmitDossier,
    AccountInfo: pageDirectories.Customer_AccountInfo,
    Introduction: pageDirectories.Customer_Introduction,
    ProcedureDetail: pageDirectories.Customer_ProcedureDetail,
    ProcedureList: pageDirectories.Customer_ProcedureList,

    ListDossierCust: pageDirectories.Customer_DossierList,
    LookUpDossier: pageDirectories.Customer_LookUpDossier,
    PublicStatistics: pageDirectories.Customer_PublicStatistics,
    Password: pageDirectories.Customer_Password,
    Paper: pageDirectories.Customer_Paper,
    Survey: pageDirectories.Customer_Survey,
};

export const pageDirectoryParameter = {
    [pageDirectories.Signin]: {
        callbackUrl: 'callbackUrl',

        /**
         * @description: Đối tượng đăng nhập không thành công
         * @author PSC Portal - Front-end developer
         * @version 1.0.0
         */
        subject: 'subject',
        /**
         * @description: Mã lỗi khi đăng nhập không thành công
         * @author PSC Portal - Front-end developer
         * @version 1.0.0
         */
        code: 'code',
        /**
         * @description: Mô tả lỗi khi đăng nhập không thành công
         * @author PSC Portal - Front-end developer
         * @version 1.0.0
         */
        email: 'email',
        /** Mô tả lỗi khi đăng nhập không thành công */
        message: 'msg',
        /**
         * @description: Thời gian đang thao tác
         */
        timestamp: 'ts',
        /**
         * @description: Cờ tự kích hoạt đăng nhập SSO khi vào /signin (giá trị 'auto').
         * Middleware gắn khi FORCE_SSO_LOGIN bật và user bị chặn ở path yêu cầu đăng nhập.
         */
        sso: 'sso',
        /**
         * @description: Đối tượng đăng nhập (LoginTarget) được gắn vào callbackUrl khi
         * login Google, để callback signIn() (auth.config.ts) đọc lại qua cookie
         * callback-url và biết nên gọi API login/google, login/student/google hay
         * gửi kèm target=Customer.
         */
        loginTarget: 'lgt',
    },
    [pageDirectories.StaffModify]: {
        userId: 'user-id',
    },
    [pageDirectories.Staff]: {
        unitCode: 'unit',
        departmentCode: 'department',
    },

    [pageDirectories.DossierDetail]: {
        action: 'act',
    },

    /**Route chi tiết xử lý hồ sơ */
    [pageDirectories.DossierProcessing]: {
        tab: 'tab',
    },

    /**Thuộc route customer */
    [pageDirectories.Customer_SubmitDossier]: {
        procedureId: 'procedure-id',
        action: 'action',
    },

    [pageDirectories.ProcedureList]: {
        fieldCode: 'field',
    },

    [pageDirectories.Customer_LookUpDossier]: {
        receiptNumber: 'receipt-number',
    },

    [pageDirectories.ModifyProcedure]: {
        /**Lưu id của thủ tục muốn sử dụng lại */
        reUseProcedureId: 're-use',
    },
};

export const errorPages = [
    pageDirectories.NotFound,
];

/**Public routes */
export const publicPages = [
    ...errorPages,
    pageDirectories.Landing,
    pageDirectories.TermOfService,
    pageDirectories.PrivacyPolicy,
    pageDirectories.Contact,
    pageDirectories.Customer_Introduction,
    pageDirectories.Customer_LookUpDossier,
    pageDirectories.Customer_ProcedureList,
    pageDirectories.Customer_ProcedureDetail,
    pageDirectories.Customer_PublicStatistics,
    pageDirectories.SignOut,
    pageDirectories.SignOutFallback,
    pageDirectories.SigninSSO,

    // '/test',
    // '/exps',
];

/**Routes for authentications includes signIn, signUp, forgetPwd */
export const authPages = [
    pageDirectories.Signin,
    pageDirectories.Signup,
    pageDirectories.Forgor,
    pageDirectories.RePassword,
    pageDirectories.SigninSSO,

    // '/third-party/google',
];

/**Client Pages */
export const clientPages = [
    ...publicPages,
    pageDirectories.Customer_AccountInfo,
    pageDirectories.Customer_DossierList,
    pageDirectories.Customer_ProcedureDetail,
    pageDirectories.Customer_SubmitDossier,
    pageDirectories.Customer_AccountInfo,
    pageDirectories.Customer_Introduction,
    pageDirectories.Customer_ProcedureList,
    pageDirectories.Customer_LookUpDossier,
    pageDirectories.Customer_Password,
    pageDirectories.Customer_Paper,
    pageDirectories.Customer_Survey,
];

/**Page for staff only*/
export const staffOnlyPages = [
    pageDirectories.Landing,
    pageDirectories.AppConfig,
    pageDirectories.Home,
    pageDirectories.Staff,
    pageDirectories.StaffModify,
    pageDirectories.Department,
    pageDirectories.Position,
    pageDirectories.Role,
    pageDirectories.WorkingGroup,
    pageDirectories.Menu,
    pageDirectories.Page,
    pageDirectories.Function,
    pageDirectories.Permission,
    pageDirectories.SsoUserSync,
    pageDirectories.ProfileInfo,
    pageDirectories.Notification,
    pageDirectories.Holiday,
    pageDirectories.WorkingSchedule,
    pageDirectories.Language,
    pageDirectories.LanguageResource,
    pageDirectories.Field,
    pageDirectories.DeclarationForm,
    pageDirectories.ModifyProcedure,
    pageDirectories.ProcedureDraftManagement,
    pageDirectories.ProcedureStaffDetail,
    pageDirectories.ProcedureList,
    pageDirectories.Customer_DossierList,
    pageDirectories.Customer,
    pageDirectories.UserServiceQuality,
    pageDirectories.Dossiers_JobImportant,
    pageDirectories.Dossiers_JobProcessing,
    pageDirectories.Dossiers_JobWaitingReceive,
    pageDirectories.Dossiers_JobTransferred,
    pageDirectories.Dossiers_DueDate,
    pageDirectories.Dossiers_ReceivedWaitingTransfer,
    pageDirectories.Dossiers_Processing,
    pageDirectories.Dossiers_StopCounting,
    pageDirectories.Dossiers_WaitingReturn,
    pageDirectories.Dossiers_Returned,
    pageDirectories.Dossiers_Refused,
    pageDirectories.Dossiers_Cancel,
    pageDirectories.Dossiers_WaitingCoordination,
    pageDirectories.Dossiers_All,
    pageDirectories.Dossiers_OverDue,
    pageDirectories.DossierDetail,
    pageDirectories.DossierProcessing,
    pageDirectories.DossiersServiceQuality,
    pageDirectories.StatisticalDetail,
    pageDirectories.AdministrativeUnit,
    pageDirectories.LegalDocument,
    pageDirectories.EmailTemplate,
    pageDirectories.AppSettings,
    pageDirectories.BusinessRequirement,
    pageDirectories.EmailSendLog,
    pageDirectories.MergeField,
    pageDirectories.EditingProcedure,
    pageDirectories.ProcedureType,

    pageDirectories.ExcelUtils,
];

/**
 * @description: Tất cả các route của phần mềm, không phân biệt là của nhân viên hay khách hàng - Dùng để xác thực route truy cập được
 * @author PSC Portal - Front-end developer
 * @version 1.0.0
 */
export const all_pages = [...clientPages, ...staffOnlyPages];

export type PageDirectory = typeof pageDirectories;
